import React from "react";

import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import Icon from "apps/website/components/base/Icon/Icon";
import cx from "apps/website/utils/misc/cx";

import { ICardOption } from "../RadioButtons.types";

const CardOption = React.forwardRef<HTMLDivElement, ICardOption>((props, ref) => (
  <div
    data-component={props.component ?? CardOption.name}
    data-value={props.value}
    aria-disabled={props.disabled}
    className={cx(
      "card-option flex flex-col items-center justify-start h-full border space-y-2 peer-focus-visible:peer-focus-visible",
      "rounded-md px-3.5 py-2 md:rounded-lg md:px-6 md:py-3",
      props.selected ? "bg-black text-white" : "border border-solid border-outline-grey bg-white",
    )}
    ref={ref}
  >
    { props.selected && props.selectedIcon
      ? <Icon icon={props.selectedIcon} size="medium" />
      : <Icon icon={props.icon} size="medium" />
    }
    <TextSubtitle
      size={2}
    >
      { props.label }
    </TextSubtitle>
    { props.description && (
      <TextBody size={2} align={"center"} className={cx(props.selected && "text-white", "transition-none")
      }>
        { props.description }
      </TextBody>
    ) }
  </div>
));

CardOption.displayName = "CardOption";

export default CardOption;
